import { extendTailwindMerge } from "tailwind-merge";
import { createTV } from "tailwind-variants";

// By default tw-resolve assumes classes like `text-caption-bold` are colors. Because it doesn't know about that class. So in this config we tell it that these classes only apply font size and weight properties. If we don't have this a twResolve("text-caption-bold", "text-blue") will resolve to "text-caption-bold" instead of "text-caption-bold text-blue" because it thinks "text-caption-bold" is a color and that "text-blue" is overriding it.
const twConfig = {
  extend: {
    classGroups: {
      "font-size": [
        "text-overline",
        "text-overline-emphasis",
        "text-caption",
        "text-caption-emphasis",
        "text-body",
        "text-body-emphasis",
        "text-heading-1",
        "text-heading-1-light",
        "text-heading-2",
        "text-heading-2-light",
        "text-heading-3",
        "text-heading-4",
        "text-figure-xl",
        "text-figure-lg",
        "text-figure-md",
      ],
      "font-weight": [
        "text-overline-emphasis",
        "text-caption-emphasis",
        "text-body-emphasis",
        "text-heading-1",
        "text-heading-1-light",
        "text-heading-2",
        "text-heading-2-light",
        "text-heading-3",
        "text-heading-4",
        "text-figure-xl",
        "text-figure-lg",
        "text-figure-md",
      ],
      "font-family": ["font-icon", "font-sans", "font-mono"],
    },
  },
} satisfies Parameters<typeof extendTailwindMerge>[0];

export const twResolve = extendTailwindMerge(twConfig);
export const twVariants = createTV({
  twMergeConfig: twConfig,
});
